const ManagerMenu = [{
    id: 1,
    link: '/user/edit-details',
    text: 'Edit Details'
  },
  {
    id: 2,
    link: '/user/change-password',
    text: 'Change Password'
  },
  // {
  //   id: 3,
  //   link: '/user/profile',
  //   text: 'Download eBook'
  // },
  {
    id: 4,
    link: '/user/manager-dashboard',
    text: 'Manager Dashboard'
  },

  // {
  //   id: 5,
  //   link: '/user/marketing-collateral',
  //   text: 'Marketing Collateral'
  // },

  {
    id: 5,
    link: '/delete-account',
    text: 'Delete Account'
  }
];

export { ManagerMenu };
